export default "__VITE_ASSET__9xK3HI8Y__"